import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a4150f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rectChartFont" }
const _hoisted_2 = { class: "checkUpType" }
const _hoisted_3 = { class: "organization" }
const _hoisted_4 = { class: "typename" }
const _hoisted_5 = { class: "typename-name" }
const _hoisted_6 = { class: "level-style" }
const _hoisted_7 = { class: "gauge1" }
const _hoisted_8 = { class: "gauge1-font" }
const _hoisted_9 = { class: "score-layout" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upline" }, null, -1))
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "score" }
const _hoisted_13 = { class: "score1" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "score2" }, "/", -1))
const _hoisted_15 = { class: "score3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "program-score" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "项目得分"),
  /*#__PURE__*/_createElementVNode("div", { class: "p2" }, "项目标准分")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downline" }, null, -1))
const _hoisted_18 = { class: "information" }
const _hoisted_19 = { class: "project-cycle" }
const _hoisted_20 = { class: "project-initiator" }
const _hoisted_21 = { class: "ultimate-person" }
const _hoisted_22 = { class: "master-number" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-font" }, "查看项目材料", -1))

import { onMounted, ref, toRefs } from 'vue'
import { useRouter } from 'vue-router';
import gauge from "@/components/gauge.vue";
import { number } from 'echarts';

export default /*#__PURE__*/_defineComponent({
  __name: 'rectChart',
  props: {
    checkup_project_id: {
        type: Number,
        default: ''
    },
    type: {
        type: String,
        default: ''
    },
    organization_name: {
        type: String,
        default: ''
    },
    level: {
        type: String,
        default: 'Z'
    },
    name: {
        type: String,
        default: ''
    },
    status: {
        type: String,
        default: ''
    },
    score: {
        type: Number,
        default: ''
    },

    standard_score: {
        type: Number,
        default: ''
    },

    start_date: {
        type: String,
        default: ''
    },

    end_date: {
        type: String,
        default: ''
    },

    added_user: {
        type: String,
        default: ''
    },

    charge_user: {
        type: String,
        default: ''
    },

    completed_percentage: {
        type: Number,
        default: ''
    },

    expert_num: {
        type: Number,
        default: ''
    },
    isFromProject: {
        type: String,
        default: '0'
    }

},
  setup(__props) {

const props = __props;

const px = ref(Math.min(window.outerHeight, window.outerWidth) * 0.26 * (1 / 3))
window.addEventListener('resize', () => {
    px.value = Math.min(window.outerHeight, window.outerWidth) * 0.26 * (1 / 3)
})

const router = useRouter()

const clickButton = async () => {
    router.push({
        name: 'ChartDetail',
        query: {
            projectId: checkup_project_id.value,
            projectName: name.value,
            organizationName: organization_name.value,
            isFromProject: isFromProject.value,
        },
    });
}

const { checkup_project_id, name, organization_name, level, isFromProject } = toRefs(props)


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.type) + "类", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(organization_name)), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(name)), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(level)==='Z'?'':_unref(level)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(gauge, {
        percentage: __props.completed_percentage,
        px: px.value,
        chartId: _unref(checkup_project_id).toString()
      }, null, 8, ["percentage", "px", "chartId"]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.status), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(__props.score), 1),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(__props.standard_score), 1)
        ]),
        _hoisted_16
      ]),
      _hoisted_17
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, "项目周期：" + _toDisplayString(__props.start_date) + " 至 " + _toDisplayString(__props.end_date), 1),
      _createElementVNode("div", _hoisted_20, "立项人：" + _toDisplayString(__props.added_user), 1),
      _createElementVNode("div", _hoisted_21, "负责人：" + _toDisplayString(__props.charge_user), 1),
      _createElementVNode("div", _hoisted_22, "专家数量：" + _toDisplayString(__props.expert_num), 1)
    ]),
    _createElementVNode("div", {
      class: "button",
      onClick: clickButton
    }, [
      _createVNode(_component_el_button, { class: "el-button" }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      })
    ])
  ]))
}
}

})